import { render, staticRenderFns } from "./PaginationNavBasic.vue?vue&type=template&id=edc62a72&"
import script from "./PaginationNavBasic.vue?vue&type=script&lang=js&"
export * from "./PaginationNavBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports